/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

"use strict";

function peg$subclass(child, parent) {
  function ctor() { this.constructor = child; }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message  = message;
  this.expected = expected;
  this.found    = found;
  this.location = location;
  this.name     = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
          return "\"" + literalEscape(expectation.text) + "\"";
        },

        "class": function(expectation) {
          var escapedParts = "",
              i;

          for (i = 0; i < expectation.parts.length; i++) {
            escapedParts += expectation.parts[i] instanceof Array
              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
              : classEscape(expectation.parts[i]);
          }

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },

        any: function(expectation) {
          return "any character";
        },

        end: function(expectation) {
          return "end of input";
        },

        other: function(expectation) {
          return expectation.description;
        }
      };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g,  '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g,  '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i, j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$DefaultTracer() {
  this.indentLevel = 0;
}

peg$DefaultTracer.prototype.trace = function(event) {
  var that = this;

  function log(event) {
    function repeat(string, n) {
       var result = "", i;

       for (i = 0; i < n; i++) {
         result += string;
       }

       return result;
    }

    function pad(string, length) {
      return string + repeat(" ", length - string.length);
    }

    if (typeof console === "object") {
      console.log(
        event.location.start.line + ":" + event.location.start.column + "-"
          + event.location.end.line + ":" + event.location.end.column + " "
          + pad(event.type, 10) + " "
          + repeat("  ", that.indentLevel) + event.rule
      );
    }
  }

  switch (event.type) {
    case "rule.enter":
      log(event);
      this.indentLevel++;
      break;

    case "rule.match":
      this.indentLevel--;
      log(event);
      break;

    case "rule.fail":
      this.indentLevel--;
      log(event);
      break;

    default:
      throw new Error("Invalid event type: " + event.type + ".");
  }
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},

      peg$startRuleFunctions = { Query: peg$parseQuery, RegExpRaw: peg$parseRegExpRaw, PhraseQuery: peg$parsePhraseQuery, WithinContainingPart: peg$parseWithinContainingPart, Sequence: peg$parseSequence },
      peg$startRuleFunction  = peg$parseQuery,

      peg$c0 = /^[,\-_\^ ]/,
      peg$c1 = peg$classExpectation([",", "-", "_", "^", " "], false, false),
      peg$c2 = /^[0-9?*+.|]/,
      peg$c3 = peg$classExpectation([["0", "9"], "?", "*", "+", ".", "|"], false, false),
      peg$c4 = "\\{",
      peg$c5 = peg$literalExpectation("\\{", false),
      peg$c6 = "\\}",
      peg$c7 = peg$literalExpectation("\\}", false),
      peg$c8 = "\\(",
      peg$c9 = peg$literalExpectation("\\(", false),
      peg$c10 = "\\)",
      peg$c11 = peg$literalExpectation("\\)", false),
      peg$c12 = "\\[",
      peg$c13 = peg$literalExpectation("\\[", false),
      peg$c14 = "\\]",
      peg$c15 = peg$literalExpectation("\\]", false),
      peg$c16 = "\\?",
      peg$c17 = peg$literalExpectation("\\?", false),
      peg$c18 = "\\!",
      peg$c19 = peg$literalExpectation("\\!", false),
      peg$c20 = "\\.",
      peg$c21 = peg$literalExpectation("\\.", false),
      peg$c22 = "\\\"",
      peg$c23 = peg$literalExpectation("\\\"", false),
      peg$c24 = "\\*",
      peg$c25 = peg$literalExpectation("\\*", false),
      peg$c26 = "\\+",
      peg$c27 = peg$literalExpectation("\\+", false),
      peg$c28 = /^[\u2019\xA8\u0259\u1D4A\u0148\u1D9C\u0161\u02B0\u010D\u1D49\u0159\u2071\u017E\u1D52\xFD\u1D58\xE1e\xEDo\xE9u\xE4\u1E01\u0142\u0141eErR\u0155\u0154tT\u0165\u0164yYuUiIoOpP\xFA\xF3\u013A\u0139\u2019\xA8\u0259\u1D4A\u0148\u1D9C\u0161\u02B0\u010D\u1D49\u0159\u2071\u017E\u1D52\xFD\u1D58\xE1e\xEDo\xE9u\xE4\u1E01\u0142\u0141eErR\u0155\u0154tT\u0165\u0164yYuUiIoOpP\xFA\xF3\u013A\u0139\u2019\xA8\u0259\u1D4A\u0148\u1D9C\u0161\u02B0\u010D\u1D49\u0159\u2071\u017E\u1D52\xFD\u1D58\xE1e\xEDo\xE9u\xE4\u1E01\u0142\u0141eErR\u0155\u0154tT\u0165\u0164yYuUiIoOpP\xFA\xF3\u013A\u0139\u013E\u013DaAsS\u015B\u015AdD\u010F\u010EfFgGhHjJkKlL]/,
      peg$c29 = peg$classExpectation(["\u2019", "\xA8", "\u0259", "\u1D4A", "\u0148", "\u1D9C", "\u0161", "\u02B0", "\u010D", "\u1D49", "\u0159", "\u2071", "\u017E", "\u1D52", "\xFD", "\u1D58", "\xE1", "e", "\xED", "o", "\xE9", "u", "\xE4", "\u1E01", "\u0142", "\u0141", "e", "E", "r", "R", "\u0155", "\u0154", "t", "T", "\u0165", "\u0164", "y", "Y", "u", "U", "i", "I", "o", "O", "p", "P", "\xFA", "\xF3", "\u013A", "\u0139", "\u2019", "\xA8", "\u0259", "\u1D4A", "\u0148", "\u1D9C", "\u0161", "\u02B0", "\u010D", "\u1D49", "\u0159", "\u2071", "\u017E", "\u1D52", "\xFD", "\u1D58", "\xE1", "e", "\xED", "o", "\xE9", "u", "\xE4", "\u1E01", "\u0142", "\u0141", "e", "E", "r", "R", "\u0155", "\u0154", "t", "T", "\u0165", "\u0164", "y", "Y", "u", "U", "i", "I", "o", "O", "p", "P", "\xFA", "\xF3", "\u013A", "\u0139", "\u2019", "\xA8", "\u0259", "\u1D4A", "\u0148", "\u1D9C", "\u0161", "\u02B0", "\u010D", "\u1D49", "\u0159", "\u2071", "\u017E", "\u1D52", "\xFD", "\u1D58", "\xE1", "e", "\xED", "o", "\xE9", "u", "\xE4", "\u1E01", "\u0142", "\u0141", "e", "E", "r", "R", "\u0155", "\u0154", "t", "T", "\u0165", "\u0164", "y", "Y", "u", "U", "i", "I", "o", "O", "p", "P", "\xFA", "\xF3", "\u013A", "\u0139", "\u013E", "\u013D", "a", "A", "s", "S", "\u015B", "\u015A", "d", "D", "\u010F", "\u010E", "f", "F", "g", "G", "h", "H", "j", "J", "k", "K", "l", "L"], false, false),
      peg$c30 = /^[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2019\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDCU00010000-U0001000BU0001000D-U00010026U00010028-U0001003AU0001003CU0001003DU0001003F-U0001004DU00010050-U0001005DU00010080-U000100FAU00010140-U00010174U00010280-U0001029CU000102A0-U000102D0U00010300-U0001031FU00010330-U0001034AU00010350-U0001037AU00010380-U0001039DU000103A0-U000103C3U000103C8-U000103CFU000103D1-U000103D5U00010400-U0001049DU00010500-U00010527U00010530-U00010563U00010600-U00010736U00010740-U00010755U00010760-U00010767U00010800-U00010805U00010808U0001080A-U00010835U00010837U00010838U0001083CU0001083F-U00010855U00010860-U00010876U00010880-U0001089EU000108E0-U000108F2U000108F4U000108F5U00010900-U00010915U00010920-U00010939U00010980-U000109B7U000109BEU000109BFU00010A00-U00010A03U00010A05U00010A06U00010A0C-U00010A13U00010A15-U00010A17U00010A19-U00010A33U00010A60-U00010A7CU00010A80-U00010A9CU00010AC0-U00010AC7U00010AC9-U00010AE4U00010B00-U00010B35U00010B40-U00010B55U00010B60-U00010B72U00010B80-U00010B91U00010C00-U00010C48U00010C80-U00010CB2U00010CC0-U00010CF2U00011000-U00011045U00011082-U000110B8U000110D0-U000110E8U00011100-U00011132U00011150-U00011172U00011176U00011180-U000111BFU000111C1-U000111C4U000111DAU000111DCU00011200-U00011211U00011213-U00011234U00011237U00011280-U00011286U00011288U0001128A-U0001128DU0001128F-U0001129DU0001129F-U000112A8U000112B0-U000112E8U00011300-U00011303U00011305-U0001130CU0001130FU00011310U00011313-U00011328U0001132A-U00011330U00011332U00011333U00011335-U00011339U0001133D-U00011344U00011347U00011348U0001134BU0001134CU00011350U00011357U0001135D-U00011363U00011480-U000114C1U000114C4U000114C5U000114C7U00011580-U000115B5U000115B8-U000115BEU000115D8-U000115DDU00011600-U0001163EU00011640U00011644U00011680-U000116B5U00011700-U00011719U0001171D-U0001172AU000118A0-U000118DFU000118FFU00011AC0-U00011AF8U00012000-U00012399U00012400-U0001246EU00012480-U00012543U00013000-U0001342EU00014400-U00014646U00016800-U00016A38U00016A40-U00016A5EU00016AD0-U00016AEDU00016B00-U00016B36U00016B40-U00016B43U00016B63-U00016B77U00016B7D-U00016B8FU00016F00-U00016F44U00016F50-U00016F7EU00016F93-U00016F9FU0001B000U0001B001U0001BC00-U0001BC6AU0001BC70-U0001BC7CU0001BC80-U0001BC88U0001BC90-U0001BC99U0001BC9EU0001D400-U0001D454U0001D456-U0001D49CU0001D49EU0001D49FU0001D4A2U0001D4A5U0001D4A6U0001D4A9-U0001D4ACU0001D4AE-U0001D4B9U0001D4BBU0001D4BD-U0001D4C3U0001D4C5-U0001D505U0001D507-U0001D50AU0001D50D-U0001D514U0001D516-U0001D51CU0001D51E-U0001D539U0001D53B-U0001D53EU0001D540-U0001D544U0001D546U0001D54A-U0001D550U0001D552-U0001D6A5U0001D6A8-U0001D6C0U0001D6C2-U0001D6DAU0001D6DC-U0001D6FAU0001D6FC-U0001D714U0001D716-U0001D734U0001D736-U0001D74EU0001D750-U0001D76EU0001D770-U0001D788U0001D78A-U0001D7A8U0001D7AA-U0001D7C2U0001D7C4-U0001D7CBU0001E800-U0001E8C4U0001EE00-U0001EE03U0001EE05-U0001EE1FU0001EE21U0001EE22U0001EE24U0001EE27U0001EE29-U0001EE32U0001EE34-U0001EE37U0001EE39U0001EE3BU0001EE42U0001EE47U0001EE49U0001EE4BU0001EE4D-U0001EE4FU0001EE51U0001EE52U0001EE54U0001EE57U0001EE59U0001EE5BU0001EE5DU0001EE5FU0001EE61U0001EE62U0001EE64U0001EE67-U0001EE6AU0001EE6C-U0001EE72U0001EE74-U0001EE77U0001EE79-U0001EE7CU0001EE7EU0001EE80-U0001EE89U0001EE8B-U0001EE9BU0001EEA1-U0001EEA3U0001EEA5-U0001EEA9U0001EEAB-U0001EEBBU0001F130-U0001F149U0001F150-U0001F169U0001F170-U0001F189U00020000-U0002A6D6U0002A700-U0002B734U0002B740-U0002B81DU0002B820-U0002CEA1U0002F800-U0002FA1D]/,
      peg$c31 = peg$classExpectation([["A", "Z"], ["a", "z"], "\xAA", "\xB5", "\xBA", ["\xC0", "\xD6"], ["\xD8", "\xF6"], ["\xF8", "\u02C1"], ["\u02C6", "\u02D1"], ["\u02E0", "\u02E4"], "\u02EC", "\u02EE", "\u0345", ["\u0370", "\u0374"], "\u0376", "\u0377", ["\u037A", "\u037D"], "\u037F", "\u0386", ["\u0388", "\u038A"], "\u038C", ["\u038E", "\u03A1"], ["\u03A3", "\u03F5"], ["\u03F7", "\u0481"], ["\u048A", "\u052F"], ["\u0531", "\u0556"], "\u0559", ["\u0561", "\u0587"], ["\u05B0", "\u05BD"], "\u05BF", "\u05C1", "\u05C2", "\u05C4", "\u05C5", "\u05C7", ["\u05D0", "\u05EA"], ["\u05F0", "\u05F2"], ["\u0610", "\u061A"], ["\u0620", "\u0657"], ["\u0659", "\u065F"], ["\u066E", "\u06D3"], ["\u06D5", "\u06DC"], ["\u06E1", "\u06E8"], ["\u06ED", "\u06EF"], ["\u06FA", "\u06FC"], "\u06FF", ["\u0710", "\u073F"], ["\u074D", "\u07B1"], ["\u07CA", "\u07EA"], "\u07F4", "\u07F5", "\u07FA", ["\u0800", "\u0817"], ["\u081A", "\u082C"], ["\u0840", "\u0858"], ["\u08A0", "\u08B4"], ["\u08E3", "\u08E9"], ["\u08F0", "\u093B"], ["\u093D", "\u094C"], ["\u094E", "\u0950"], ["\u0955", "\u0963"], ["\u0971", "\u0983"], ["\u0985", "\u098C"], "\u098F", "\u0990", ["\u0993", "\u09A8"], ["\u09AA", "\u09B0"], "\u09B2", ["\u09B6", "\u09B9"], ["\u09BD", "\u09C4"], "\u09C7", "\u09C8", "\u09CB", "\u09CC", "\u09CE", "\u09D7", "\u09DC", "\u09DD", ["\u09DF", "\u09E3"], "\u09F0", "\u09F1", ["\u0A01", "\u0A03"], ["\u0A05", "\u0A0A"], "\u0A0F", "\u0A10", ["\u0A13", "\u0A28"], ["\u0A2A", "\u0A30"], "\u0A32", "\u0A33", "\u0A35", "\u0A36", "\u0A38", "\u0A39", ["\u0A3E", "\u0A42"], "\u0A47", "\u0A48", "\u0A4B", "\u0A4C", "\u0A51", ["\u0A59", "\u0A5C"], "\u0A5E", ["\u0A70", "\u0A75"], ["\u0A81", "\u0A83"], ["\u0A85", "\u0A8D"], ["\u0A8F", "\u0A91"], ["\u0A93", "\u0AA8"], ["\u0AAA", "\u0AB0"], "\u0AB2", "\u0AB3", ["\u0AB5", "\u0AB9"], ["\u0ABD", "\u0AC5"], ["\u0AC7", "\u0AC9"], "\u0ACB", "\u0ACC", "\u0AD0", ["\u0AE0", "\u0AE3"], "\u0AF9", ["\u0B01", "\u0B03"], ["\u0B05", "\u0B0C"], "\u0B0F", "\u0B10", ["\u0B13", "\u0B28"], ["\u0B2A", "\u0B30"], "\u0B32", "\u0B33", ["\u0B35", "\u0B39"], ["\u0B3D", "\u0B44"], "\u0B47", "\u0B48", "\u0B4B", "\u0B4C", "\u0B56", "\u0B57", "\u0B5C", "\u0B5D", ["\u0B5F", "\u0B63"], "\u0B71", "\u0B82", "\u0B83", ["\u0B85", "\u0B8A"], ["\u0B8E", "\u0B90"], ["\u0B92", "\u0B95"], "\u0B99", "\u0B9A", "\u0B9C", "\u0B9E", "\u0B9F", "\u0BA3", "\u0BA4", ["\u0BA8", "\u0BAA"], ["\u0BAE", "\u0BB9"], ["\u0BBE", "\u0BC2"], ["\u0BC6", "\u0BC8"], ["\u0BCA", "\u0BCC"], "\u0BD0", "\u0BD7", ["\u0C00", "\u0C03"], ["\u0C05", "\u0C0C"], ["\u0C0E", "\u0C10"], ["\u0C12", "\u0C28"], ["\u0C2A", "\u0C39"], ["\u0C3D", "\u0C44"], ["\u0C46", "\u0C48"], ["\u0C4A", "\u0C4C"], "\u0C55", "\u0C56", ["\u0C58", "\u0C5A"], ["\u0C60", "\u0C63"], ["\u0C81", "\u0C83"], ["\u0C85", "\u0C8C"], ["\u0C8E", "\u0C90"], ["\u0C92", "\u0CA8"], ["\u0CAA", "\u0CB3"], ["\u0CB5", "\u0CB9"], ["\u0CBD", "\u0CC4"], ["\u0CC6", "\u0CC8"], ["\u0CCA", "\u0CCC"], "\u0CD5", "\u0CD6", "\u0CDE", ["\u0CE0", "\u0CE3"], "\u0CF1", "\u0CF2", ["\u0D01", "\u0D03"], ["\u0D05", "\u0D0C"], ["\u0D0E", "\u0D10"], ["\u0D12", "\u0D3A"], ["\u0D3D", "\u0D44"], ["\u0D46", "\u0D48"], ["\u0D4A", "\u0D4C"], "\u0D4E", "\u0D57", ["\u0D5F", "\u0D63"], ["\u0D7A", "\u0D7F"], "\u0D82", "\u0D83", ["\u0D85", "\u0D96"], ["\u0D9A", "\u0DB1"], ["\u0DB3", "\u0DBB"], "\u0DBD", ["\u0DC0", "\u0DC6"], ["\u0DCF", "\u0DD4"], "\u0DD6", ["\u0DD8", "\u0DDF"], "\u0DF2", "\u0DF3", ["\u0E01", "\u0E3A"], ["\u0E40", "\u0E46"], "\u0E4D", "\u0E81", "\u0E82", "\u0E84", "\u0E87", "\u0E88", "\u0E8A", "\u0E8D", ["\u0E94", "\u0E97"], ["\u0E99", "\u0E9F"], ["\u0EA1", "\u0EA3"], "\u0EA5", "\u0EA7", "\u0EAA", "\u0EAB", ["\u0EAD", "\u0EB9"], ["\u0EBB", "\u0EBD"], ["\u0EC0", "\u0EC4"], "\u0EC6", "\u0ECD", ["\u0EDC", "\u0EDF"], "\u0F00", ["\u0F40", "\u0F47"], ["\u0F49", "\u0F6C"], ["\u0F71", "\u0F81"], ["\u0F88", "\u0F97"], ["\u0F99", "\u0FBC"], ["\u1000", "\u1036"], "\u1038", ["\u103B", "\u103F"], ["\u1050", "\u1062"], ["\u1065", "\u1068"], ["\u106E", "\u1086"], "\u108E", "\u109C", "\u109D", ["\u10A0", "\u10C5"], "\u10C7", "\u10CD", ["\u10D0", "\u10FA"], ["\u10FC", "\u1248"], ["\u124A", "\u124D"], ["\u1250", "\u1256"], "\u1258", ["\u125A", "\u125D"], ["\u1260", "\u1288"], ["\u128A", "\u128D"], ["\u1290", "\u12B0"], ["\u12B2", "\u12B5"], ["\u12B8", "\u12BE"], "\u12C0", ["\u12C2", "\u12C5"], ["\u12C8", "\u12D6"], ["\u12D8", "\u1310"], ["\u1312", "\u1315"], ["\u1318", "\u135A"], "\u135F", ["\u1380", "\u138F"], ["\u13A0", "\u13F5"], ["\u13F8", "\u13FD"], ["\u1401", "\u166C"], ["\u166F", "\u167F"], ["\u1681", "\u169A"], ["\u16A0", "\u16EA"], ["\u16EE", "\u16F8"], ["\u1700", "\u170C"], ["\u170E", "\u1713"], ["\u1720", "\u1733"], ["\u1740", "\u1753"], ["\u1760", "\u176C"], ["\u176E", "\u1770"], "\u1772", "\u1773", ["\u1780", "\u17B3"], ["\u17B6", "\u17C8"], "\u17D7", "\u17DC", ["\u1820", "\u1877"], ["\u1880", "\u18AA"], ["\u18B0", "\u18F5"], ["\u1900", "\u191E"], ["\u1920", "\u192B"], ["\u1930", "\u1938"], ["\u1950", "\u196D"], ["\u1970", "\u1974"], ["\u1980", "\u19AB"], ["\u19B0", "\u19C9"], ["\u1A00", "\u1A1B"], ["\u1A20", "\u1A5E"], ["\u1A61", "\u1A74"], "\u1AA7", ["\u1B00", "\u1B33"], ["\u1B35", "\u1B43"], ["\u1B45", "\u1B4B"], ["\u1B80", "\u1BA9"], ["\u1BAC", "\u1BAF"], ["\u1BBA", "\u1BE5"], ["\u1BE7", "\u1BF1"], ["\u1C00", "\u1C35"], ["\u1C4D", "\u1C4F"], ["\u1C5A", "\u1C7D"], ["\u1CE9", "\u1CEC"], ["\u1CEE", "\u1CF3"], "\u1CF5", "\u1CF6", ["\u1D00", "\u1DBF"], ["\u1DE7", "\u1DF4"], ["\u1E00", "\u1F15"], ["\u1F18", "\u1F1D"], ["\u1F20", "\u1F45"], ["\u1F48", "\u1F4D"], ["\u1F50", "\u1F57"], "\u1F59", "\u1F5B", "\u1F5D", ["\u1F5F", "\u1F7D"], ["\u1F80", "\u1FB4"], ["\u1FB6", "\u1FBC"], "\u1FBE", ["\u1FC2", "\u1FC4"], ["\u1FC6", "\u1FCC"], ["\u1FD0", "\u1FD3"], ["\u1FD6", "\u1FDB"], ["\u1FE0", "\u1FEC"], ["\u1FF2", "\u1FF4"], ["\u1FF6", "\u1FFC"], "\u2019", "\u2071", "\u207F", ["\u2090", "\u209C"], "\u2102", "\u2107", ["\u210A", "\u2113"], "\u2115", ["\u2119", "\u211D"], "\u2124", "\u2126", "\u2128", ["\u212A", "\u212D"], ["\u212F", "\u2139"], ["\u213C", "\u213F"], ["\u2145", "\u2149"], "\u214E", ["\u2160", "\u2188"], ["\u24B6", "\u24E9"], ["\u2C00", "\u2C2E"], ["\u2C30", "\u2C5E"], ["\u2C60", "\u2CE4"], ["\u2CEB", "\u2CEE"], "\u2CF2", "\u2CF3", ["\u2D00", "\u2D25"], "\u2D27", "\u2D2D", ["\u2D30", "\u2D67"], "\u2D6F", ["\u2D80", "\u2D96"], ["\u2DA0", "\u2DA6"], ["\u2DA8", "\u2DAE"], ["\u2DB0", "\u2DB6"], ["\u2DB8", "\u2DBE"], ["\u2DC0", "\u2DC6"], ["\u2DC8", "\u2DCE"], ["\u2DD0", "\u2DD6"], ["\u2DD8", "\u2DDE"], ["\u2DE0", "\u2DFF"], "\u2E2F", ["\u3005", "\u3007"], ["\u3021", "\u3029"], ["\u3031", "\u3035"], ["\u3038", "\u303C"], ["\u3041", "\u3096"], ["\u309D", "\u309F"], ["\u30A1", "\u30FA"], ["\u30FC", "\u30FF"], ["\u3105", "\u312D"], ["\u3131", "\u318E"], ["\u31A0", "\u31BA"], ["\u31F0", "\u31FF"], ["\u3400", "\u4DB5"], ["\u4E00", "\u9FD5"], ["\uA000", "\uA48C"], ["\uA4D0", "\uA4FD"], ["\uA500", "\uA60C"], ["\uA610", "\uA61F"], "\uA62A", "\uA62B", ["\uA640", "\uA66E"], ["\uA674", "\uA67B"], ["\uA67F", "\uA6EF"], ["\uA717", "\uA71F"], ["\uA722", "\uA788"], ["\uA78B", "\uA7AD"], ["\uA7B0", "\uA7B7"], ["\uA7F7", "\uA801"], ["\uA803", "\uA805"], ["\uA807", "\uA80A"], ["\uA80C", "\uA827"], ["\uA840", "\uA873"], ["\uA880", "\uA8C3"], ["\uA8F2", "\uA8F7"], "\uA8FB", "\uA8FD", ["\uA90A", "\uA92A"], ["\uA930", "\uA952"], ["\uA960", "\uA97C"], ["\uA980", "\uA9B2"], ["\uA9B4", "\uA9BF"], "\uA9CF", ["\uA9E0", "\uA9E4"], ["\uA9E6", "\uA9EF"], ["\uA9FA", "\uA9FE"], ["\uAA00", "\uAA36"], ["\uAA40", "\uAA4D"], ["\uAA60", "\uAA76"], "\uAA7A", ["\uAA7E", "\uAABE"], "\uAAC0", "\uAAC2", ["\uAADB", "\uAADD"], ["\uAAE0", "\uAAEF"], ["\uAAF2", "\uAAF5"], ["\uAB01", "\uAB06"], ["\uAB09", "\uAB0E"], ["\uAB11", "\uAB16"], ["\uAB20", "\uAB26"], ["\uAB28", "\uAB2E"], ["\uAB30", "\uAB5A"], ["\uAB5C", "\uAB65"], ["\uAB70", "\uABEA"], ["\uAC00", "\uD7A3"], ["\uD7B0", "\uD7C6"], ["\uD7CB", "\uD7FB"], ["\uF900", "\uFA6D"], ["\uFA70", "\uFAD9"], ["\uFB00", "\uFB06"], ["\uFB13", "\uFB17"], ["\uFB1D", "\uFB28"], ["\uFB2A", "\uFB36"], ["\uFB38", "\uFB3C"], "\uFB3E", "\uFB40", "\uFB41", "\uFB43", "\uFB44", ["\uFB46", "\uFBB1"], ["\uFBD3", "\uFD3D"], ["\uFD50", "\uFD8F"], ["\uFD92", "\uFDC7"], ["\uFDF0", "\uFDFB"], ["\uFE70", "\uFE74"], ["\uFE76", "\uFEFC"], ["\uFF21", "\uFF3A"], ["\uFF41", "\uFF5A"], ["\uFF66", "\uFFBE"], ["\uFFC2", "\uFFC7"], ["\uFFCA", "\uFFCF"], ["\uFFD2", "\uFFD7"], ["\uFFDA", "\uFFDC"], "U", "0", "0", "0", "1", "0", "0", "0", ["0", "U"], "0", "0", "0", "1", "0", "0", "0", "B", "U", "0", "0", "0", "1", "0", "0", "0", ["D", "U"], "0", "0", "0", "1", "0", "0", "2", "6", "U", "0", "0", "0", "1", "0", "0", "2", ["8", "U"], "0", "0", "0", "1", "0", "0", "3", "A", "U", "0", "0", "0", "1", "0", "0", "3", "C", "U", "0", "0", "0", "1", "0", "0", "3", "D", "U", "0", "0", "0", "1", "0", "0", "3", ["F", "U"], "0", "0", "0", "1", "0", "0", "4", "D", "U", "0", "0", "0", "1", "0", "0", "5", ["0", "U"], "0", "0", "0", "1", "0", "0", "5", "D", "U", "0", "0", "0", "1", "0", "0", "8", ["0", "U"], "0", "0", "0", "1", "0", "0", "F", "A", "U", "0", "0", "0", "1", "0", "1", "4", ["0", "U"], "0", "0", "0", "1", "0", "1", "7", "4", "U", "0", "0", "0", "1", "0", "2", "8", ["0", "U"], "0", "0", "0", "1", "0", "2", "9", "C", "U", "0", "0", "0", "1", "0", "2", "A", ["0", "U"], "0", "0", "0", "1", "0", "2", "D", "0", "U", "0", "0", "0", "1", "0", "3", "0", ["0", "U"], "0", "0", "0", "1", "0", "3", "1", "F", "U", "0", "0", "0", "1", "0", "3", "3", ["0", "U"], "0", "0", "0", "1", "0", "3", "4", "A", "U", "0", "0", "0", "1", "0", "3", "5", ["0", "U"], "0", "0", "0", "1", "0", "3", "7", "A", "U", "0", "0", "0", "1", "0", "3", "8", ["0", "U"], "0", "0", "0", "1", "0", "3", "9", "D", "U", "0", "0", "0", "1", "0", "3", "A", ["0", "U"], "0", "0", "0", "1", "0", "3", "C", "3", "U", "0", "0", "0", "1", "0", "3", "C", ["8", "U"], "0", "0", "0", "1", "0", "3", "C", "F", "U", "0", "0", "0", "1", "0", "3", "D", ["1", "U"], "0", "0", "0", "1", "0", "3", "D", "5", "U", "0", "0", "0", "1", "0", "4", "0", ["0", "U"], "0", "0", "0", "1", "0", "4", "9", "D", "U", "0", "0", "0", "1", "0", "5", "0", ["0", "U"], "0", "0", "0", "1", "0", "5", "2", "7", "U", "0", "0", "0", "1", "0", "5", "3", ["0", "U"], "0", "0", "0", "1", "0", "5", "6", "3", "U", "0", "0", "0", "1", "0", "6", "0", ["0", "U"], "0", "0", "0", "1", "0", "7", "3", "6", "U", "0", "0", "0", "1", "0", "7", "4", ["0", "U"], "0", "0", "0", "1", "0", "7", "5", "5", "U", "0", "0", "0", "1", "0", "7", "6", ["0", "U"], "0", "0", "0", "1", "0", "7", "6", "7", "U", "0", "0", "0", "1", "0", "8", "0", ["0", "U"], "0", "0", "0", "1", "0", "8", "0", "5", "U", "0", "0", "0", "1", "0", "8", "0", "8", "U", "0", "0", "0", "1", "0", "8", "0", ["A", "U"], "0", "0", "0", "1", "0", "8", "3", "5", "U", "0", "0", "0", "1", "0", "8", "3", "7", "U", "0", "0", "0", "1", "0", "8", "3", "8", "U", "0", "0", "0", "1", "0", "8", "3", "C", "U", "0", "0", "0", "1", "0", "8", "3", ["F", "U"], "0", "0", "0", "1", "0", "8", "5", "5", "U", "0", "0", "0", "1", "0", "8", "6", ["0", "U"], "0", "0", "0", "1", "0", "8", "7", "6", "U", "0", "0", "0", "1", "0", "8", "8", ["0", "U"], "0", "0", "0", "1", "0", "8", "9", "E", "U", "0", "0", "0", "1", "0", "8", "E", ["0", "U"], "0", "0", "0", "1", "0", "8", "F", "2", "U", "0", "0", "0", "1", "0", "8", "F", "4", "U", "0", "0", "0", "1", "0", "8", "F", "5", "U", "0", "0", "0", "1", "0", "9", "0", ["0", "U"], "0", "0", "0", "1", "0", "9", "1", "5", "U", "0", "0", "0", "1", "0", "9", "2", ["0", "U"], "0", "0", "0", "1", "0", "9", "3", "9", "U", "0", "0", "0", "1", "0", "9", "8", ["0", "U"], "0", "0", "0", "1", "0", "9", "B", "7", "U", "0", "0", "0", "1", "0", "9", "B", "E", "U", "0", "0", "0", "1", "0", "9", "B", "F", "U", "0", "0", "0", "1", "0", "A", "0", ["0", "U"], "0", "0", "0", "1", "0", "A", "0", "3", "U", "0", "0", "0", "1", "0", "A", "0", "5", "U", "0", "0", "0", "1", "0", "A", "0", "6", "U", "0", "0", "0", "1", "0", "A", "0", ["C", "U"], "0", "0", "0", "1", "0", "A", "1", "3", "U", "0", "0", "0", "1", "0", "A", "1", ["5", "U"], "0", "0", "0", "1", "0", "A", "1", "7", "U", "0", "0", "0", "1", "0", "A", "1", ["9", "U"], "0", "0", "0", "1", "0", "A", "3", "3", "U", "0", "0", "0", "1", "0", "A", "6", ["0", "U"], "0", "0", "0", "1", "0", "A", "7", "C", "U", "0", "0", "0", "1", "0", "A", "8", ["0", "U"], "0", "0", "0", "1", "0", "A", "9", "C", "U", "0", "0", "0", "1", "0", "A", "C", ["0", "U"], "0", "0", "0", "1", "0", "A", "C", "7", "U", "0", "0", "0", "1", "0", "A", "C", ["9", "U"], "0", "0", "0", "1", "0", "A", "E", "4", "U", "0", "0", "0", "1", "0", "B", "0", ["0", "U"], "0", "0", "0", "1", "0", "B", "3", "5", "U", "0", "0", "0", "1", "0", "B", "4", ["0", "U"], "0", "0", "0", "1", "0", "B", "5", "5", "U", "0", "0", "0", "1", "0", "B", "6", ["0", "U"], "0", "0", "0", "1", "0", "B", "7", "2", "U", "0", "0", "0", "1", "0", "B", "8", ["0", "U"], "0", "0", "0", "1", "0", "B", "9", "1", "U", "0", "0", "0", "1", "0", "C", "0", ["0", "U"], "0", "0", "0", "1", "0", "C", "4", "8", "U", "0", "0", "0", "1", "0", "C", "8", ["0", "U"], "0", "0", "0", "1", "0", "C", "B", "2", "U", "0", "0", "0", "1", "0", "C", "C", ["0", "U"], "0", "0", "0", "1", "0", "C", "F", "2", "U", "0", "0", "0", "1", "1", "0", "0", ["0", "U"], "0", "0", "0", "1", "1", "0", "4", "5", "U", "0", "0", "0", "1", "1", "0", "8", ["2", "U"], "0", "0", "0", "1", "1", "0", "B", "8", "U", "0", "0", "0", "1", "1", "0", "D", ["0", "U"], "0", "0", "0", "1", "1", "0", "E", "8", "U", "0", "0", "0", "1", "1", "1", "0", ["0", "U"], "0", "0", "0", "1", "1", "1", "3", "2", "U", "0", "0", "0", "1", "1", "1", "5", ["0", "U"], "0", "0", "0", "1", "1", "1", "7", "2", "U", "0", "0", "0", "1", "1", "1", "7", "6", "U", "0", "0", "0", "1", "1", "1", "8", ["0", "U"], "0", "0", "0", "1", "1", "1", "B", "F", "U", "0", "0", "0", "1", "1", "1", "C", ["1", "U"], "0", "0", "0", "1", "1", "1", "C", "4", "U", "0", "0", "0", "1", "1", "1", "D", "A", "U", "0", "0", "0", "1", "1", "1", "D", "C", "U", "0", "0", "0", "1", "1", "2", "0", ["0", "U"], "0", "0", "0", "1", "1", "2", "1", "1", "U", "0", "0", "0", "1", "1", "2", "1", ["3", "U"], "0", "0", "0", "1", "1", "2", "3", "4", "U", "0", "0", "0", "1", "1", "2", "3", "7", "U", "0", "0", "0", "1", "1", "2", "8", ["0", "U"], "0", "0", "0", "1", "1", "2", "8", "6", "U", "0", "0", "0", "1", "1", "2", "8", "8", "U", "0", "0", "0", "1", "1", "2", "8", ["A", "U"], "0", "0", "0", "1", "1", "2", "8", "D", "U", "0", "0", "0", "1", "1", "2", "8", ["F", "U"], "0", "0", "0", "1", "1", "2", "9", "D", "U", "0", "0", "0", "1", "1", "2", "9", ["F", "U"], "0", "0", "0", "1", "1", "2", "A", "8", "U", "0", "0", "0", "1", "1", "2", "B", ["0", "U"], "0", "0", "0", "1", "1", "2", "E", "8", "U", "0", "0", "0", "1", "1", "3", "0", ["0", "U"], "0", "0", "0", "1", "1", "3", "0", "3", "U", "0", "0", "0", "1", "1", "3", "0", ["5", "U"], "0", "0", "0", "1", "1", "3", "0", "C", "U", "0", "0", "0", "1", "1", "3", "0", "F", "U", "0", "0", "0", "1", "1", "3", "1", "0", "U", "0", "0", "0", "1", "1", "3", "1", ["3", "U"], "0", "0", "0", "1", "1", "3", "2", "8", "U", "0", "0", "0", "1", "1", "3", "2", ["A", "U"], "0", "0", "0", "1", "1", "3", "3", "0", "U", "0", "0", "0", "1", "1", "3", "3", "2", "U", "0", "0", "0", "1", "1", "3", "3", "3", "U", "0", "0", "0", "1", "1", "3", "3", ["5", "U"], "0", "0", "0", "1", "1", "3", "3", "9", "U", "0", "0", "0", "1", "1", "3", "3", ["D", "U"], "0", "0", "0", "1", "1", "3", "4", "4", "U", "0", "0", "0", "1", "1", "3", "4", "7", "U", "0", "0", "0", "1", "1", "3", "4", "8", "U", "0", "0", "0", "1", "1", "3", "4", "B", "U", "0", "0", "0", "1", "1", "3", "4", "C", "U", "0", "0", "0", "1", "1", "3", "5", "0", "U", "0", "0", "0", "1", "1", "3", "5", "7", "U", "0", "0", "0", "1", "1", "3", "5", ["D", "U"], "0", "0", "0", "1", "1", "3", "6", "3", "U", "0", "0", "0", "1", "1", "4", "8", ["0", "U"], "0", "0", "0", "1", "1", "4", "C", "1", "U", "0", "0", "0", "1", "1", "4", "C", "4", "U", "0", "0", "0", "1", "1", "4", "C", "5", "U", "0", "0", "0", "1", "1", "4", "C", "7", "U", "0", "0", "0", "1", "1", "5", "8", ["0", "U"], "0", "0", "0", "1", "1", "5", "B", "5", "U", "0", "0", "0", "1", "1", "5", "B", ["8", "U"], "0", "0", "0", "1", "1", "5", "B", "E", "U", "0", "0", "0", "1", "1", "5", "D", ["8", "U"], "0", "0", "0", "1", "1", "5", "D", "D", "U", "0", "0", "0", "1", "1", "6", "0", ["0", "U"], "0", "0", "0", "1", "1", "6", "3", "E", "U", "0", "0", "0", "1", "1", "6", "4", "0", "U", "0", "0", "0", "1", "1", "6", "4", "4", "U", "0", "0", "0", "1", "1", "6", "8", ["0", "U"], "0", "0", "0", "1", "1", "6", "B", "5", "U", "0", "0", "0", "1", "1", "7", "0", ["0", "U"], "0", "0", "0", "1", "1", "7", "1", "9", "U", "0", "0", "0", "1", "1", "7", "1", ["D", "U"], "0", "0", "0", "1", "1", "7", "2", "A", "U", "0", "0", "0", "1", "1", "8", "A", ["0", "U"], "0", "0", "0", "1", "1", "8", "D", "F", "U", "0", "0", "0", "1", "1", "8", "F", "F", "U", "0", "0", "0", "1", "1", "A", "C", ["0", "U"], "0", "0", "0", "1", "1", "A", "F", "8", "U", "0", "0", "0", "1", "2", "0", "0", ["0", "U"], "0", "0", "0", "1", "2", "3", "9", "9", "U", "0", "0", "0", "1", "2", "4", "0", ["0", "U"], "0", "0", "0", "1", "2", "4", "6", "E", "U", "0", "0", "0", "1", "2", "4", "8", ["0", "U"], "0", "0", "0", "1", "2", "5", "4", "3", "U", "0", "0", "0", "1", "3", "0", "0", ["0", "U"], "0", "0", "0", "1", "3", "4", "2", "E", "U", "0", "0", "0", "1", "4", "4", "0", ["0", "U"], "0", "0", "0", "1", "4", "6", "4", "6", "U", "0", "0", "0", "1", "6", "8", "0", ["0", "U"], "0", "0", "0", "1", "6", "A", "3", "8", "U", "0", "0", "0", "1", "6", "A", "4", ["0", "U"], "0", "0", "0", "1", "6", "A", "5", "E", "U", "0", "0", "0", "1", "6", "A", "D", ["0", "U"], "0", "0", "0", "1", "6", "A", "E", "D", "U", "0", "0", "0", "1", "6", "B", "0", ["0", "U"], "0", "0", "0", "1", "6", "B", "3", "6", "U", "0", "0", "0", "1", "6", "B", "4", ["0", "U"], "0", "0", "0", "1", "6", "B", "4", "3", "U", "0", "0", "0", "1", "6", "B", "6", ["3", "U"], "0", "0", "0", "1", "6", "B", "7", "7", "U", "0", "0", "0", "1", "6", "B", "7", ["D", "U"], "0", "0", "0", "1", "6", "B", "8", "F", "U", "0", "0", "0", "1", "6", "F", "0", ["0", "U"], "0", "0", "0", "1", "6", "F", "4", "4", "U", "0", "0", "0", "1", "6", "F", "5", ["0", "U"], "0", "0", "0", "1", "6", "F", "7", "E", "U", "0", "0", "0", "1", "6", "F", "9", ["3", "U"], "0", "0", "0", "1", "6", "F", "9", "F", "U", "0", "0", "0", "1", "B", "0", "0", "0", "U", "0", "0", "0", "1", "B", "0", "0", "1", "U", "0", "0", "0", "1", "B", "C", "0", ["0", "U"], "0", "0", "0", "1", "B", "C", "6", "A", "U", "0", "0", "0", "1", "B", "C", "7", ["0", "U"], "0", "0", "0", "1", "B", "C", "7", "C", "U", "0", "0", "0", "1", "B", "C", "8", ["0", "U"], "0", "0", "0", "1", "B", "C", "8", "8", "U", "0", "0", "0", "1", "B", "C", "9", ["0", "U"], "0", "0", "0", "1", "B", "C", "9", "9", "U", "0", "0", "0", "1", "B", "C", "9", "E", "U", "0", "0", "0", "1", "D", "4", "0", ["0", "U"], "0", "0", "0", "1", "D", "4", "5", "4", "U", "0", "0", "0", "1", "D", "4", "5", ["6", "U"], "0", "0", "0", "1", "D", "4", "9", "C", "U", "0", "0", "0", "1", "D", "4", "9", "E", "U", "0", "0", "0", "1", "D", "4", "9", "F", "U", "0", "0", "0", "1", "D", "4", "A", "2", "U", "0", "0", "0", "1", "D", "4", "A", "5", "U", "0", "0", "0", "1", "D", "4", "A", "6", "U", "0", "0", "0", "1", "D", "4", "A", ["9", "U"], "0", "0", "0", "1", "D", "4", "A", "C", "U", "0", "0", "0", "1", "D", "4", "A", ["E", "U"], "0", "0", "0", "1", "D", "4", "B", "9", "U", "0", "0", "0", "1", "D", "4", "B", "B", "U", "0", "0", "0", "1", "D", "4", "B", ["D", "U"], "0", "0", "0", "1", "D", "4", "C", "3", "U", "0", "0", "0", "1", "D", "4", "C", ["5", "U"], "0", "0", "0", "1", "D", "5", "0", "5", "U", "0", "0", "0", "1", "D", "5", "0", ["7", "U"], "0", "0", "0", "1", "D", "5", "0", "A", "U", "0", "0", "0", "1", "D", "5", "0", ["D", "U"], "0", "0", "0", "1", "D", "5", "1", "4", "U", "0", "0", "0", "1", "D", "5", "1", ["6", "U"], "0", "0", "0", "1", "D", "5", "1", "C", "U", "0", "0", "0", "1", "D", "5", "1", ["E", "U"], "0", "0", "0", "1", "D", "5", "3", "9", "U", "0", "0", "0", "1", "D", "5", "3", ["B", "U"], "0", "0", "0", "1", "D", "5", "3", "E", "U", "0", "0", "0", "1", "D", "5", "4", ["0", "U"], "0", "0", "0", "1", "D", "5", "4", "4", "U", "0", "0", "0", "1", "D", "5", "4", "6", "U", "0", "0", "0", "1", "D", "5", "4", ["A", "U"], "0", "0", "0", "1", "D", "5", "5", "0", "U", "0", "0", "0", "1", "D", "5", "5", ["2", "U"], "0", "0", "0", "1", "D", "6", "A", "5", "U", "0", "0", "0", "1", "D", "6", "A", ["8", "U"], "0", "0", "0", "1", "D", "6", "C", "0", "U", "0", "0", "0", "1", "D", "6", "C", ["2", "U"], "0", "0", "0", "1", "D", "6", "D", "A", "U", "0", "0", "0", "1", "D", "6", "D", ["C", "U"], "0", "0", "0", "1", "D", "6", "F", "A", "U", "0", "0", "0", "1", "D", "6", "F", ["C", "U"], "0", "0", "0", "1", "D", "7", "1", "4", "U", "0", "0", "0", "1", "D", "7", "1", ["6", "U"], "0", "0", "0", "1", "D", "7", "3", "4", "U", "0", "0", "0", "1", "D", "7", "3", ["6", "U"], "0", "0", "0", "1", "D", "7", "4", "E", "U", "0", "0", "0", "1", "D", "7", "5", ["0", "U"], "0", "0", "0", "1", "D", "7", "6", "E", "U", "0", "0", "0", "1", "D", "7", "7", ["0", "U"], "0", "0", "0", "1", "D", "7", "8", "8", "U", "0", "0", "0", "1", "D", "7", "8", ["A", "U"], "0", "0", "0", "1", "D", "7", "A", "8", "U", "0", "0", "0", "1", "D", "7", "A", ["A", "U"], "0", "0", "0", "1", "D", "7", "C", "2", "U", "0", "0", "0", "1", "D", "7", "C", ["4", "U"], "0", "0", "0", "1", "D", "7", "C", "B", "U", "0", "0", "0", "1", "E", "8", "0", ["0", "U"], "0", "0", "0", "1", "E", "8", "C", "4", "U", "0", "0", "0", "1", "E", "E", "0", ["0", "U"], "0", "0", "0", "1", "E", "E", "0", "3", "U", "0", "0", "0", "1", "E", "E", "0", ["5", "U"], "0", "0", "0", "1", "E", "E", "1", "F", "U", "0", "0", "0", "1", "E", "E", "2", "1", "U", "0", "0", "0", "1", "E", "E", "2", "2", "U", "0", "0", "0", "1", "E", "E", "2", "4", "U", "0", "0", "0", "1", "E", "E", "2", "7", "U", "0", "0", "0", "1", "E", "E", "2", ["9", "U"], "0", "0", "0", "1", "E", "E", "3", "2", "U", "0", "0", "0", "1", "E", "E", "3", ["4", "U"], "0", "0", "0", "1", "E", "E", "3", "7", "U", "0", "0", "0", "1", "E", "E", "3", "9", "U", "0", "0", "0", "1", "E", "E", "3", "B", "U", "0", "0", "0", "1", "E", "E", "4", "2", "U", "0", "0", "0", "1", "E", "E", "4", "7", "U", "0", "0", "0", "1", "E", "E", "4", "9", "U", "0", "0", "0", "1", "E", "E", "4", "B", "U", "0", "0", "0", "1", "E", "E", "4", ["D", "U"], "0", "0", "0", "1", "E", "E", "4", "F", "U", "0", "0", "0", "1", "E", "E", "5", "1", "U", "0", "0", "0", "1", "E", "E", "5", "2", "U", "0", "0", "0", "1", "E", "E", "5", "4", "U", "0", "0", "0", "1", "E", "E", "5", "7", "U", "0", "0", "0", "1", "E", "E", "5", "9", "U", "0", "0", "0", "1", "E", "E", "5", "B", "U", "0", "0", "0", "1", "E", "E", "5", "D", "U", "0", "0", "0", "1", "E", "E", "5", "F", "U", "0", "0", "0", "1", "E", "E", "6", "1", "U", "0", "0", "0", "1", "E", "E", "6", "2", "U", "0", "0", "0", "1", "E", "E", "6", "4", "U", "0", "0", "0", "1", "E", "E", "6", ["7", "U"], "0", "0", "0", "1", "E", "E", "6", "A", "U", "0", "0", "0", "1", "E", "E", "6", ["C", "U"], "0", "0", "0", "1", "E", "E", "7", "2", "U", "0", "0", "0", "1", "E", "E", "7", ["4", "U"], "0", "0", "0", "1", "E", "E", "7", "7", "U", "0", "0", "0", "1", "E", "E", "7", ["9", "U"], "0", "0", "0", "1", "E", "E", "7", "C", "U", "0", "0", "0", "1", "E", "E", "7", "E", "U", "0", "0", "0", "1", "E", "E", "8", ["0", "U"], "0", "0", "0", "1", "E", "E", "8", "9", "U", "0", "0", "0", "1", "E", "E", "8", ["B", "U"], "0", "0", "0", "1", "E", "E", "9", "B", "U", "0", "0", "0", "1", "E", "E", "A", ["1", "U"], "0", "0", "0", "1", "E", "E", "A", "3", "U", "0", "0", "0", "1", "E", "E", "A", ["5", "U"], "0", "0", "0", "1", "E", "E", "A", "9", "U", "0", "0", "0", "1", "E", "E", "A", ["B", "U"], "0", "0", "0", "1", "E", "E", "B", "B", "U", "0", "0", "0", "1", "F", "1", "3", ["0", "U"], "0", "0", "0", "1", "F", "1", "4", "9", "U", "0", "0", "0", "1", "F", "1", "5", ["0", "U"], "0", "0", "0", "1", "F", "1", "6", "9", "U", "0", "0", "0", "1", "F", "1", "7", ["0", "U"], "0", "0", "0", "1", "F", "1", "8", "9", "U", "0", "0", "0", "2", "0", "0", "0", ["0", "U"], "0", "0", "0", "2", "A", "6", "D", "6", "U", "0", "0", "0", "2", "A", "7", "0", ["0", "U"], "0", "0", "0", "2", "B", "7", "3", "4", "U", "0", "0", "0", "2", "B", "7", "4", ["0", "U"], "0", "0", "0", "2", "B", "8", "1", "D", "U", "0", "0", "0", "2", "B", "8", "2", ["0", "U"], "0", "0", "0", "2", "C", "E", "A", "1", "U", "0", "0", "0", "2", "F", "8", "0", ["0", "U"], "0", "0", "0", "2", "F", "A", "1", "D"], false, false),
      peg$c32 = /^[0-9]/,
      peg$c33 = peg$classExpectation([["0", "9"]], false, false),
      peg$c34 = "-",
      peg$c35 = peg$literalExpectation("-", false),
      peg$c36 = /^[a-zA-Z]/,
      peg$c37 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false),
      peg$c38 = /^[a-zA-Z0-9@_]/,
      peg$c39 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "@", "_"], false, false),
      peg$c40 = "\"",
      peg$c41 = peg$literalExpectation("\"", false),
      peg$c42 = "(",
      peg$c43 = peg$literalExpectation("(", false),
      peg$c44 = ")",
      peg$c45 = peg$literalExpectation(")", false),
      peg$c46 = "[",
      peg$c47 = peg$literalExpectation("[", false),
      peg$c48 = "]",
      peg$c49 = peg$literalExpectation("]", false),
      peg$c50 = "{",
      peg$c51 = peg$literalExpectation("{", false),
      peg$c52 = "}",
      peg$c53 = peg$literalExpectation("}", false),
      peg$c54 = "*",
      peg$c55 = peg$literalExpectation("*", false),
      peg$c56 = "+",
      peg$c57 = peg$literalExpectation("+", false),
      peg$c58 = "?",
      peg$c59 = peg$literalExpectation("?", false),
      peg$c60 = "|",
      peg$c61 = peg$literalExpectation("|", false),
      peg$c62 = "&",
      peg$c63 = peg$literalExpectation("&", false),
      peg$c64 = ".",
      peg$c65 = peg$literalExpectation(".", false),
      peg$c66 = ",",
      peg$c67 = peg$literalExpectation(",", false),
      peg$c68 = ";",
      peg$c69 = peg$literalExpectation(";", false),
      peg$c70 = ":",
      peg$c71 = peg$literalExpectation(":", false),
      peg$c72 = "=",
      peg$c73 = peg$literalExpectation("=", false),
      peg$c74 = "==",
      peg$c75 = peg$literalExpectation("==", false),
      peg$c76 = "~",
      peg$c77 = peg$literalExpectation("~", false),
      peg$c78 = "!",
      peg$c79 = peg$literalExpectation("!", false),
      peg$c80 = "<=",
      peg$c81 = peg$literalExpectation("<=", false),
      peg$c82 = ">=",
      peg$c83 = peg$literalExpectation(">=", false),
      peg$c84 = "<",
      peg$c85 = peg$literalExpectation("<", false),
      peg$c86 = ">",
      peg$c87 = peg$literalExpectation(">", false),
      peg$c88 = "/",
      peg$c89 = peg$literalExpectation("/", false),
      peg$c90 = "#",
      peg$c91 = peg$literalExpectation("#", false),
      peg$c92 = "meet",
      peg$c93 = peg$literalExpectation("meet", false),
      peg$c94 = "union",
      peg$c95 = peg$literalExpectation("union", false),
      peg$c96 = "within",
      peg$c97 = peg$literalExpectation("within", false),
      peg$c98 = "containing",
      peg$c99 = peg$literalExpectation("containing", false),
      peg$c100 = "MU",
      peg$c101 = peg$literalExpectation("MU", false),
      peg$c102 = "f",
      peg$c103 = peg$literalExpectation("f", false),
      peg$c104 = "ws",
      peg$c105 = peg$literalExpectation("ws", false),
      peg$c106 = "term",
      peg$c107 = peg$literalExpectation("term", false),
      peg$c108 = "swap",
      peg$c109 = peg$literalExpectation("swap", false),
      peg$c110 = "ccoll",
      peg$c111 = peg$literalExpectation("ccoll", false),
      peg$c112 = peg$otherExpectation("whitespace"),
      peg$c113 = /^[ \t\n\r]/,
      peg$c114 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),

      peg$currPos          = 0,
      peg$savedPos         = 0,
      peg$posDetailsCache  = [{ line: 1, column: 1 }],
      peg$maxFailPos       = 0,
      peg$maxFailExpected  = [],
      peg$silentFails      = 0,

      peg$tracer = "tracer" in options ? options.tracer : new peg$DefaultTracer(),

      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos], p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line:   details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails   = peg$computePosDetails(endPos);

    return {
      start: {
        offset: startPos,
        line:   startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line:   endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseQuery() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Query",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseSequence();
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parseBINAND();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s6 = peg$parseGlobPart();
            if (s6 !== peg$FAILED) {
              s3 = [s3, s4, s5, s6];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$currPos;
        s5 = peg$parse_();
        if (s5 !== peg$FAILED) {
          s6 = peg$parseNOT();
          if (s6 === peg$FAILED) {
            s6 = null;
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$parseKW_WITHIN();
            if (s7 === peg$FAILED) {
              s7 = peg$parseKW_CONTAINING();
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parse_();
              if (s8 !== peg$FAILED) {
                s9 = peg$parseWithinContainingPart();
                if (s9 !== peg$FAILED) {
                  s5 = [s5, s6, s7, s8, s9];
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$currPos;
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s6 = peg$parseNOT();
            if (s6 === peg$FAILED) {
              s6 = null;
            }
            if (s6 !== peg$FAILED) {
              s7 = peg$parseKW_WITHIN();
              if (s7 === peg$FAILED) {
                s7 = peg$parseKW_CONTAINING();
              }
              if (s7 !== peg$FAILED) {
                s8 = peg$parse_();
                if (s8 !== peg$FAILED) {
                  s9 = peg$parseWithinContainingPart();
                  if (s9 !== peg$FAILED) {
                    s5 = [s5, s6, s7, s8, s9];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parseSEMI();
          if (s4 !== peg$FAILED) {
            s1 = [s1, s2, s3, s4];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Query",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Query",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseGlobPart() {
    var s0, s1, s2, s3, s4, s5, s6, s7,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "GlobPart",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseGlobCond();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse_();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseBINAND();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_();
          if (s6 !== peg$FAILED) {
            s7 = peg$parseGlobCond();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseBINAND();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseGlobCond();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "GlobPart",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "GlobPart",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseGlobCond() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "GlobCond",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseNUMBER();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseDOT();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseAttName();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseNOT();
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parseEQ();
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseNUMBER();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseDOT();
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parseAttName();
                      if (s10 !== peg$FAILED) {
                        s1 = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10];
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_FREQ();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseLPAREN();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseNUMBER();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseDOT();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseAttName();
              if (s5 !== peg$FAILED) {
                s6 = peg$parseRPAREN();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseNOT();
                  if (s7 === peg$FAILED) {
                    s7 = null;
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseEQ();
                      if (s9 === peg$FAILED) {
                        s9 = peg$parseLEQ();
                        if (s9 === peg$FAILED) {
                          s9 = peg$parseGEQ();
                          if (s9 === peg$FAILED) {
                            s9 = peg$parseLSTRUCT();
                            if (s9 === peg$FAILED) {
                              s9 = peg$parseRSTRUCT();
                            }
                          }
                        }
                      }
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          s11 = peg$parseNUMBER();
                          if (s11 !== peg$FAILED) {
                            s1 = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11];
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "GlobCond",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "GlobCond",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseWithinContainingPart() {
    var s0, s1, s2,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "WithinContainingPart",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseSequence();
    if (s0 === peg$FAILED) {
      s0 = peg$parseNUMBER();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseNOT();
        if (s1 === peg$FAILED) {
          s1 = null;
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parseAlignedPart();
          if (s2 !== peg$FAILED) {
            s1 = [s1, s2];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "WithinContainingPart",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "WithinContainingPart",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseStructure() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Structure",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAttName();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseAttValList();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Structure",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Structure",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parsePosition() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Position",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseOnePosition();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseNUMBER();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseCOLON();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseOnePosition();
          if (s3 !== peg$FAILED) {
            s1 = [s1, s2, s3];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Position",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Position",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseOnePosition() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "OnePosition",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseLBRACKET();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseAttValList();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseRBRACKET();
            if (s5 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4, s5];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseRegExp();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseTEQ();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseNUMBER();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseRegExp();
            if (s3 !== peg$FAILED) {
              s1 = [s1, s2, s3];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$parseKW_MU();
          if (s0 === peg$FAILED) {
            s0 = peg$parseMuPart();
          }
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "OnePosition",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "OnePosition",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseMuPart() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "MuPart",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseUnionOp();
        if (s3 === peg$FAILED) {
          s3 = peg$parseMeetOp();
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseRPAREN();
            if (s5 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4, s5];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "MuPart",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "MuPart",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseInteger() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Integer",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseNUMBER();
    if (s0 === peg$FAILED) {
      s0 = peg$parseNNUMBER();
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Integer",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Integer",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseMeetOp() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "MeetOp",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseKW_MEET();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parsePosition();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parsePosition();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                s8 = peg$parseInteger();
                if (s8 !== peg$FAILED) {
                  s9 = peg$parse_();
                  if (s9 !== peg$FAILED) {
                    s10 = peg$parseInteger();
                    if (s10 !== peg$FAILED) {
                      s8 = [s8, s9, s10];
                      s7 = s8;
                    } else {
                      peg$currPos = s7;
                      s7 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s7;
                    s7 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s7;
                  s7 = peg$FAILED;
                }
                if (s7 === peg$FAILED) {
                  s7 = null;
                }
                if (s7 !== peg$FAILED) {
                  s1 = [s1, s2, s3, s4, s5, s6, s7];
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "MeetOp",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "MeetOp",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseUnionOp() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "UnionOp",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseKW_UNION();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parsePosition();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parsePosition();
            if (s5 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4, s5];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "UnionOp",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "UnionOp",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseSequence() {
    var s0, s1, s2, s3, s4, s5, s6, s7,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Sequence",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseSeq();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseSeq();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseBINOR();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseSeq();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseBINOR();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseSeq();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Sequence",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Sequence",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseSeq() {
    var s0, s1, s2, s3, s4, s5, s6,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Seq",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseNOT();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseRepetition();
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$currPos;
        s5 = peg$parse_();
        if (s5 !== peg$FAILED) {
          s6 = peg$parseRepetition();
          if (s6 !== peg$FAILED) {
            s5 = [s5, s6];
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$currPos;
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s6 = peg$parseRepetition();
            if (s6 !== peg$FAILED) {
              s5 = [s5, s6];
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        }
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Seq",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Seq",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRepetition() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "Repetition",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAtomQuery();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseRepOpt();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseLSTRUCT();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseStructure();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseSLASH();
            if (s4 === peg$FAILED) {
              s4 = null;
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseRSTRUCT();
              if (s5 !== peg$FAILED) {
                s1 = [s1, s2, s3, s4, s5];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseLSTRUCT();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseSLASH();
          if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
              s4 = peg$parseStructure();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseRSTRUCT();
                if (s5 !== peg$FAILED) {
                  s1 = [s1, s2, s3, s4, s5];
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "Repetition",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "Repetition",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAtomQuery() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AtomQuery",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parsePosition();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseLPAREN();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseSequence();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s6 = peg$parseNOT();
            if (s6 === peg$FAILED) {
              s6 = null;
            }
            if (s6 !== peg$FAILED) {
              s7 = peg$parseKW_WITHIN();
              if (s7 === peg$FAILED) {
                s7 = peg$parseKW_CONTAINING();
              }
              if (s7 !== peg$FAILED) {
                s8 = peg$parse_();
                if (s8 !== peg$FAILED) {
                  s9 = peg$parseWithinContainingPart();
                  if (s9 !== peg$FAILED) {
                    s5 = [s5, s6, s7, s8, s9];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parseNOT();
              if (s6 === peg$FAILED) {
                s6 = null;
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parseKW_WITHIN();
                if (s7 === peg$FAILED) {
                  s7 = peg$parseKW_CONTAINING();
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseWithinContainingPart();
                    if (s9 !== peg$FAILED) {
                      s5 = [s5, s6, s7, s8, s9];
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parseRPAREN();
            if (s4 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AtomQuery",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AtomQuery",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAlignedPart() {
    var s0, s1, s2, s3, s4,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AlignedPart",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAttName();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseCOLON();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseSequence();
          if (s4 !== peg$FAILED) {
            s1 = [s1, s2, s3, s4];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AlignedPart",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AlignedPart",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAttValList() {
    var s0, s1, s2, s3, s4, s5, s6, s7,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AttValList",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAttValAnd();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse_();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseBINOR();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_();
          if (s6 !== peg$FAILED) {
            s7 = peg$parseAttValAnd();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseBINOR();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseAttValAnd();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AttValList",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AttValList",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAttValAnd() {
    var s0, s1, s2, s3, s4, s5, s6, s7,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AttValAnd",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAttVal();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse_();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseBINAND();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_();
          if (s6 !== peg$FAILED) {
            s7 = peg$parseAttVal();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseBINAND();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseAttVal();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AttValAnd",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AttValAnd",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAttVal() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AttVal",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseAttName();
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parseNOT();
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseEQ();
        if (s3 === peg$FAILED) {
          s3 = peg$parseLEQ();
          if (s3 === peg$FAILED) {
            s3 = peg$parseGEQ();
            if (s3 === peg$FAILED) {
              s3 = peg$currPos;
              s4 = peg$parseTEQ();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseNUMBER();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                if (s5 !== peg$FAILED) {
                  s4 = [s4, s5];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            }
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseRegExp();
            if (s5 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4, s5];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsePOSNUM();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseNUMBER();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseDASH();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseNUMBER();
            if (s4 !== peg$FAILED) {
              s1 = [s1, s2, s3, s4];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsePOSNUM();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseNUMBER();
          if (s2 !== peg$FAILED) {
            s1 = [s1, s2];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseNOT();
          if (s1 !== peg$FAILED) {
            s2 = peg$parseAttVal();
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseLPAREN();
            if (s1 !== peg$FAILED) {
              s2 = peg$parseAttValList();
              if (s2 !== peg$FAILED) {
                s3 = peg$parseRPAREN();
                if (s3 !== peg$FAILED) {
                  s1 = [s1, s2, s3];
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseKW_WS();
              if (s1 === peg$FAILED) {
                s1 = peg$parseKW_TERM();
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parseLPAREN();
                if (s2 !== peg$FAILED) {
                  s3 = peg$currPos;
                  s4 = peg$parseNUMBER();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parseCOMMA();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parseNUMBER();
                      if (s6 !== peg$FAILED) {
                        s4 = [s4, s5, s6];
                        s3 = s4;
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 === peg$FAILED) {
                    s3 = peg$currPos;
                    s4 = peg$parseRegExp();
                    if (s4 !== peg$FAILED) {
                      s5 = peg$parseCOMMA();
                      if (s5 !== peg$FAILED) {
                        s6 = peg$parseRegExp();
                        if (s6 !== peg$FAILED) {
                          s7 = peg$parseCOMMA();
                          if (s7 !== peg$FAILED) {
                            s8 = peg$parseRegExp();
                            if (s8 !== peg$FAILED) {
                              s4 = [s4, s5, s6, s7, s8];
                              s3 = s4;
                            } else {
                              peg$currPos = s3;
                              s3 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  }
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parseRPAREN();
                    if (s4 !== peg$FAILED) {
                      s1 = [s1, s2, s3, s4];
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseKW_SWAP();
                if (s1 !== peg$FAILED) {
                  s2 = peg$parseLPAREN();
                  if (s2 !== peg$FAILED) {
                    s3 = peg$parseNUMBER();
                    if (s3 !== peg$FAILED) {
                      s4 = peg$parseCOMMA();
                      if (s4 !== peg$FAILED) {
                        s5 = peg$parseAttValList();
                        if (s5 !== peg$FAILED) {
                          s6 = peg$parseRPAREN();
                          if (s6 !== peg$FAILED) {
                            s1 = [s1, s2, s3, s4, s5, s6];
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parseKW_CCOLL();
                  if (s1 !== peg$FAILED) {
                    s2 = peg$parseLPAREN();
                    if (s2 !== peg$FAILED) {
                      s3 = peg$parseNUMBER();
                      if (s3 !== peg$FAILED) {
                        s4 = peg$parseCOMMA();
                        if (s4 !== peg$FAILED) {
                          s5 = peg$parseNUMBER();
                          if (s5 !== peg$FAILED) {
                            s6 = peg$parseCOMMA();
                            if (s6 !== peg$FAILED) {
                              s7 = peg$parseAttValList();
                              if (s7 !== peg$FAILED) {
                                s8 = peg$parseRPAREN();
                                if (s8 !== peg$FAILED) {
                                  s1 = [s1, s2, s3, s4, s5, s6, s7, s8];
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                }
              }
            }
          }
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AttVal",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AttVal",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRepOpt() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RepOpt",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseSTAR();
    if (s0 === peg$FAILED) {
      s0 = peg$parsePLUS();
      if (s0 === peg$FAILED) {
        s0 = peg$parseQUEST();
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseLBRACE();
          if (s1 !== peg$FAILED) {
            s2 = peg$parseNUMBER();
            if (s2 !== peg$FAILED) {
              s3 = peg$currPos;
              s4 = peg$parseCOMMA();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseNUMBER();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                if (s5 !== peg$FAILED) {
                  s4 = [s4, s5];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
              if (s3 === peg$FAILED) {
                s3 = null;
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parseRBRACE();
                if (s4 !== peg$FAILED) {
                  s1 = [s1, s2, s3, s4];
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RepOpt",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RepOpt",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAttName() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AttName",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseATTR_CHARS();
    if (s0 === peg$FAILED) {
      s0 = peg$parseASCII_LETTERS();
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AttName",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AttName",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parsePhraseQuery() {
    var s0, s1, s2, s3, s4, s5,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "PhraseQuery",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseRegExpRaw();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse_();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseRegExpRaw();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseRegExpRaw();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "PhraseQuery",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "PhraseQuery",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRegExp() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RegExp",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseQUOT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseRegExpRaw();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseQUOT();
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseQUOT();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseQUOT();
        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RegExp",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RegExp",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRegExpRaw() {
    var s0, s1,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RegExpRaw",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = [];
    s1 = peg$parseRgGrouped();
    if (s1 === peg$FAILED) {
      s1 = peg$parseRgSimple();
    }
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        s1 = peg$parseRgGrouped();
        if (s1 === peg$FAILED) {
          s1 = peg$parseRgSimple();
        }
      }
    } else {
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RegExpRaw",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RegExpRaw",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgGrouped() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgGrouped",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseRegExpRaw();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseRPAREN();
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgGrouped",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgGrouped",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgSimple() {
    var s0, s1,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgSimple",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = [];
    s1 = peg$parseRgRange();
    if (s1 === peg$FAILED) {
      s1 = peg$parseRgChar();
      if (s1 === peg$FAILED) {
        s1 = peg$parseRgAlt();
      }
    }
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        s1 = peg$parseRgRange();
        if (s1 === peg$FAILED) {
          s1 = peg$parseRgChar();
          if (s1 === peg$FAILED) {
            s1 = peg$parseRgAlt();
          }
        }
      }
    } else {
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgSimple",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgSimple",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgAlt() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgAlt",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseLBRACKET();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseRgChar();
      if (s3 === peg$FAILED) {
        s3 = peg$parseDASH();
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseRgChar();
          if (s3 === peg$FAILED) {
            s3 = peg$parseDASH();
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseRBRACKET();
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgAlt",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgAlt",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgChar() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgChar",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseRG_ESCAPED();
    if (s0 === peg$FAILED) {
      s0 = peg$parseAnyLetter();
      if (s0 === peg$FAILED) {
        s0 = peg$parseRG_OP();
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgChar",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgChar",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRG_OP() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RG_OP",
      location: peg$computeLocation(startPos, startPos)
    });

    if (peg$c0.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c1); }
    }
    if (s0 === peg$FAILED) {
      if (peg$c2.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c3); }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RG_OP",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RG_OP",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRG_ESCAPED() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RG_ESCAPED",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c4) {
      s0 = peg$c4;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c6) {
        s0 = peg$c6;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c7); }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c8) {
          s0 = peg$c8;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c9); }
        }
        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c10) {
            s0 = peg$c10;
            peg$currPos += 2;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c12) {
              s0 = peg$c12;
              peg$currPos += 2;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c13); }
            }
            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c14) {
                s0 = peg$c14;
                peg$currPos += 2;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c15); }
              }
              if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c16) {
                  s0 = peg$c16;
                  peg$currPos += 2;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c17); }
                }
                if (s0 === peg$FAILED) {
                  if (input.substr(peg$currPos, 2) === peg$c18) {
                    s0 = peg$c18;
                    peg$currPos += 2;
                  } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c19); }
                  }
                  if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c20) {
                      s0 = peg$c20;
                      peg$currPos += 2;
                    } else {
                      s0 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c21); }
                    }
                    if (s0 === peg$FAILED) {
                      if (input.substr(peg$currPos, 2) === peg$c22) {
                        s0 = peg$c22;
                        peg$currPos += 2;
                      } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c23); }
                      }
                      if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 2) === peg$c24) {
                          s0 = peg$c24;
                          peg$currPos += 2;
                        } else {
                          s0 = peg$FAILED;
                          if (peg$silentFails === 0) { peg$fail(peg$c25); }
                        }
                        if (s0 === peg$FAILED) {
                          if (input.substr(peg$currPos, 2) === peg$c26) {
                            s0 = peg$c26;
                            peg$currPos += 2;
                          } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$c27); }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RG_ESCAPED",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RG_ESCAPED",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgRange() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgRange",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseLBRACE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseRgRangeSpec();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseRBRACE();
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgRange",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgRange",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRgRangeSpec() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RgRangeSpec",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    s1 = peg$parseNUMBER();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseCOMMA();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseNUMBER();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseNUMBER();
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RgRangeSpec",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RgRangeSpec",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseAnyLetter() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "AnyLetter",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$parseLETTER();
    if (s0 === peg$FAILED) {
      s0 = peg$parseLETTER_PHON();
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "AnyLetter",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "AnyLetter",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLETTER_PHON() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LETTER_PHON",
      location: peg$computeLocation(startPos, startPos)
    });

    if (peg$c28.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c29); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LETTER_PHON",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LETTER_PHON",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLETTER() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LETTER",
      location: peg$computeLocation(startPos, startPos)
    });

    if (peg$c30.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c31); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LETTER",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LETTER",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseNUMBER() {
    var s0, s1,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "NUMBER",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = [];
    if (peg$c32.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c33); }
    }
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        if (peg$c32.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c33); }
        }
      }
    } else {
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "NUMBER",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "NUMBER",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseNNUMBER() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "NNUMBER",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 45) {
      s1 = peg$c34;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c35); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      if (peg$c32.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c33); }
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c32.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c33); }
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "NNUMBER",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "NNUMBER",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseASCII_LETTERS() {
    var s0, s1,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "ASCII_LETTERS",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = [];
    if (peg$c36.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        if (peg$c36.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c37); }
        }
      }
    } else {
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "ASCII_LETTERS",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "ASCII_LETTERS",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseATTR_CHARS() {
    var s0, s1, s2, s3,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "ATTR_CHARS",
      location: peg$computeLocation(startPos, startPos)
    });

    s0 = peg$currPos;
    if (peg$c36.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      if (peg$c38.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c39); }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        if (peg$c38.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c39); }
        }
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "ATTR_CHARS",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "ATTR_CHARS",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseQUOT() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "QUOT",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 34) {
      s0 = peg$c40;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c41); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "QUOT",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "QUOT",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseDASH() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "DASH",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 45) {
      s0 = peg$c34;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c35); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "DASH",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "DASH",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLPAREN() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LPAREN",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 40) {
      s0 = peg$c42;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c43); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LPAREN",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LPAREN",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRPAREN() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RPAREN",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 41) {
      s0 = peg$c44;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c45); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RPAREN",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RPAREN",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLBRACKET() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LBRACKET",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 91) {
      s0 = peg$c46;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c47); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LBRACKET",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LBRACKET",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRBRACKET() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RBRACKET",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 93) {
      s0 = peg$c48;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c49); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RBRACKET",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RBRACKET",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLBRACE() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LBRACE",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 123) {
      s0 = peg$c50;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c51); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LBRACE",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LBRACE",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRBRACE() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RBRACE",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 125) {
      s0 = peg$c52;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c53); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RBRACE",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RBRACE",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseSTAR() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "STAR",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 42) {
      s0 = peg$c54;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c55); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "STAR",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "STAR",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parsePLUS() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "PLUS",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 43) {
      s0 = peg$c56;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c57); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "PLUS",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "PLUS",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseQUEST() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "QUEST",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 63) {
      s0 = peg$c58;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c59); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "QUEST",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "QUEST",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseBINOR() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "BINOR",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 124) {
      s0 = peg$c60;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c61); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "BINOR",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "BINOR",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseBINAND() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "BINAND",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 38) {
      s0 = peg$c62;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c63); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "BINAND",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "BINAND",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseDOT() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "DOT",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 46) {
      s0 = peg$c64;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c65); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "DOT",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "DOT",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseCOMMA() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "COMMA",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 44) {
      s0 = peg$c66;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c67); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "COMMA",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "COMMA",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseSEMI() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "SEMI",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 59) {
      s0 = peg$c68;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c69); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "SEMI",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "SEMI",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseCOLON() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "COLON",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 58) {
      s0 = peg$c70;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c71); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "COLON",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "COLON",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseEQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "EQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 61) {
      s0 = peg$c72;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c73); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "EQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "EQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseEEQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "EEQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c74) {
      s0 = peg$c74;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c75); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "EEQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "EEQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseTEQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "TEQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 126) {
      s0 = peg$c76;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c77); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "TEQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "TEQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseNOT() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "NOT",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 33) {
      s0 = peg$c78;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c79); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "NOT",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "NOT",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLEQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LEQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c80) {
      s0 = peg$c80;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c81); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LEQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LEQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseGEQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "GEQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c82) {
      s0 = peg$c82;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c83); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "GEQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "GEQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseLSTRUCT() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "LSTRUCT",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 60) {
      s0 = peg$c84;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c85); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "LSTRUCT",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "LSTRUCT",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseRSTRUCT() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "RSTRUCT",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 62) {
      s0 = peg$c86;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c87); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "RSTRUCT",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "RSTRUCT",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseSLASH() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "SLASH",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 47) {
      s0 = peg$c88;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c89); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "SLASH",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "SLASH",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parsePOSNUM() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "POSNUM",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 35) {
      s0 = peg$c90;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c91); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "POSNUM",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "POSNUM",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_MEET() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_MEET",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 4) === peg$c92) {
      s0 = peg$c92;
      peg$currPos += 4;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c93); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_MEET",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_MEET",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_UNION() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_UNION",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 5) === peg$c94) {
      s0 = peg$c94;
      peg$currPos += 5;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c95); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_UNION",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_UNION",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_WITHIN() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_WITHIN",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 6) === peg$c96) {
      s0 = peg$c96;
      peg$currPos += 6;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c97); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_WITHIN",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_WITHIN",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_CONTAINING() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_CONTAINING",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 10) === peg$c98) {
      s0 = peg$c98;
      peg$currPos += 10;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c99); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_CONTAINING",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_CONTAINING",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_MU() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_MU",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c100) {
      s0 = peg$c100;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c101); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_MU",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_MU",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_FREQ() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_FREQ",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.charCodeAt(peg$currPos) === 102) {
      s0 = peg$c102;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c103); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_FREQ",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_FREQ",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_WS() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_WS",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 2) === peg$c104) {
      s0 = peg$c104;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c105); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_WS",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_WS",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_TERM() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_TERM",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 4) === peg$c106) {
      s0 = peg$c106;
      peg$currPos += 4;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c107); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_TERM",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_TERM",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_SWAP() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_SWAP",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 4) === peg$c108) {
      s0 = peg$c108;
      peg$currPos += 4;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c109); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_SWAP",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_SWAP",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parseKW_CCOLL() {
    var s0,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "KW_CCOLL",
      location: peg$computeLocation(startPos, startPos)
    });

    if (input.substr(peg$currPos, 5) === peg$c110) {
      s0 = peg$c110;
      peg$currPos += 5;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c111); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "KW_CCOLL",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "KW_CCOLL",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1,
        startPos = peg$currPos;

    peg$tracer.trace({
      type:     "rule.enter",
      rule:     "_",
      location: peg$computeLocation(startPos, startPos)
    });

    peg$silentFails++;
    s0 = [];
    if (peg$c113.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c114); }
    }
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      if (peg$c113.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c114); }
      }
    }
    peg$silentFails--;
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c112); }
    }

    if (s0 !== peg$FAILED) {
      peg$tracer.trace({
        type:   "rule.match",
        rule:   "_",
        result: s0,
        location: peg$computeLocation(startPos, peg$currPos)
      });
    } else {
      peg$tracer.trace({
        type: "rule.fail",
        rule: "_",
        location: peg$computeLocation(startPos, startPos)
      });
    }

    return s0;
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

module.exports = {
  SyntaxError:   peg$SyntaxError,
  DefaultTracer: peg$DefaultTracer,
  parse:         peg$parse
};
